'use client';

import { usePathname } from 'next/navigation';
import { useTranslations } from 'next-intl';
import { accountMenuSections } from '@/features/settings/model/account-menu';
import { BackButton } from '@/shared/ui';
import { AccountSubpageNav } from './AccountSubpageNav';

/**
 * Mobile-only header for account sub-pages.
 * Shows a back button (→ /account) and the page title.
 * Title is resolved from the account menu config by matching the current pathname.
 */
export function MobileAccountHeader() {
  const pathname = usePathname();
  const t = useTranslations('account');

  // Don't show on the root account page (it IS the menu)
  if (pathname === '/account') return null;

  // Find menu item: exact match first, then longest prefix match for nested pages
  const allItems = accountMenuSections.flatMap((s) => s.items);
  const exactMatch = allItems.find((item) => item.href === pathname);
  const prefixMatch = !exactMatch
    ? allItems
        .filter((item) => item.href && pathname.startsWith(item.href + '/'))
        .sort((a, b) => b.href.length - a.href.length)[0]
    : undefined;

  const menuItem = exactMatch || prefixMatch;
  const title = menuItem ? t(menuItem.labelKey) : undefined;

  return (
    <div className="sticky top-0 z-10 flex items-center h-11 bg-background/80 backdrop-blur-md border-b border-border">
      <BackButton href="/account" size="compact" className="ms-1" />
      {title && (
        <span className="absolute left-1/2 -translate-x-1/2 text-card-title text-foreground truncate max-w-[60%] pointer-events-none">
          {title}
        </span>
      )}
      <div className="ms-auto pe-2">
        <AccountSubpageNav />
      </div>
    </div>
  );
}
